import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  ref,
  watch,
  useAttrs,
  withDefaults,
} from 'vue'
import CUSkeletonLoaderTextField from '@/components/CUSkeletonLoaderTextField.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CUSelect',
  props: {
    displaySelectAll: { type: Boolean },
    skeletonLoader: { type: Boolean },
    aggregateSelectionIndex: null,
    itemText: null,
    itemValue: null,
    items: null,
    value: null,
    multiple: { type: Boolean },
    required: { type: Boolean }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: any): void
  (e: 'change', value: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  displaySelectAll?: boolean
  skeletonLoader?: boolean
  aggregateSelectionIndex?: number
  itemText?: string
  itemValue?: string
  items?: any[]
  value?: number | string | unknown[]
  multiple?: boolean
  required?: boolean
};





const attrs = useAttrs()
const isAllToggled = ref(true)

// Watch for changes in value to update isAllToggled
watch(
  () => props.value,
  (newVal) => {
    if (!props.multiple) {
      return
    }

    if (newVal?.length === props.items?.length) {
      isAllToggled.value = true
    } else {
      isAllToggled.value = false
    }
  },
  { immediate: true }
)

const listeners = computed(() => {
  return {
    ...attrs,
    input: (event: InputEvent) => {
      emit('input', event)
    },
    change: (event: InputEvent) => {
      emit('change', event)
    },
  }
})

const aggregateSelectionText = (item: any, index: number): string => {
  if (!props.aggregateSelectionIndex || !props.value) {
    return ''
  }

  const appendText =
    index !== props.aggregateSelectionIndex - 1 &&
    props.value.length - 1 > index
      ? ', '
      : ''
  return `${item[props.itemText || 'text']}${appendText}`
}

const toggleAllFilters = (): void => {
  if (!isAllToggled.value) {
    if (props.itemValue) {
      emit(
        'input',
        props.items?.map((item) => item[props.itemValue || 'value'])
      )
    } else {
      emit('input', props.items)
    }
  } else {
    emit('input', [])
  }
}

return { __sfc: true,props, emit, attrs, isAllToggled, listeners, aggregateSelectionText, toggleAllFilters, CUSkeletonLoaderTextField }
}

})